import * as yup from 'yup';

export type TValues = {
  answerText?: string;
};

export const validationSchema = yup.object({
  answerText: yup.string().required('Обязательное поле'),
});
